import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CaptchaService } from "../../../services/captcha.service";
import { ProductService } from "../../../../core/services/products.service";
import { I18nService } from "../../../services";

@Component({
  selector: "app-exclusive-content-modal",
  templateUrl: "./exclusive-content-modal.component.html",
  styleUrls: ["./exclusive-content-modal.component.scss"]
})
export class ExclusiveContentModalComponent implements OnInit {
  form: FormGroup;
  imgCaptcha = "";
  textCaptcha = "";
  errorCaptcha = false;

  constructor(
    private fb: FormBuilder,
    private captchaService: CaptchaService,
    private productService: ProductService,
    private snackBar: MatSnackBar,
    private i18: I18nService,
    private dialogRef: MatDialogRef<ExclusiveContentModalComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
        ]
      ],
      inputCaptcha: [""]
    });
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    this.captchaService.generateCaptcha();
    this.imgCaptcha = this.captchaService.imgCaptcha;
    this.textCaptcha = this.captchaService.textCaptcha;
  }

  validateCaptcha(): boolean {
    this.errorCaptcha =
      this.form.get("inputCaptcha")?.value !== this.textCaptcha ||
      !this.form.get("inputCaptcha")?.value;
    return !this.errorCaptcha;
  }

  submit(): void {
    const message = this.i18.get("global.newsForm.message");
    const action = this.i18.get("global.newsForm.action");
    const errorMsj = this.i18.get("global.newsForm.errorMsj");
    this.validateCaptcha();
    if (this.form.valid && !this.errorCaptcha) {
      this.productService.sendEmail(this.form.value.email).subscribe(
        () => {
          this.snackBar.open(message, action);
          this.dialogRef.close();
        },
        () => {
          this.snackBar.open(errorMsj, action);
        }
      );
    }
  }
}
